import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';

import { ErrorPageComponent } from './error-page/error-page.component';

// Leaves the error page via a full page load rather than an in-app navigation, so the app
// bootstraps clean after whatever error put the user here.
export const errorGuard: CanDeactivateFn<ErrorPageComponent> = (
  _component: ErrorPageComponent,
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  nextState: RouterStateSnapshot
): boolean => {
  window.location.href = nextState.url;
  return true;
};
